import * as React from "react";
import { Article } from "@/types/index";
import Search from "@/components/Search";
import ArticleCard from "../ArticleCard";
import Sorter from "@/components/Comparison/Sorter";

const ArticlesList: React.FC<{
	articles: Array<Article>;
}> = ({ articles }) => {
	const [articleSorter, setArticleSorter] =
		React.useState<string>("newest-to-oldest");
	const [articleFilter, setArticleFilter] = React.useState<string>("");
	const [sortedArticles, setSortedArticles] = React.useState<Array<Article>>(
		[]
	);
	const [currentPage, setCurrentPage] = React.useState<number>(1);
	const [pageSize] = React.useState<number>(9);

	React.useEffect(() => {
		let sorted = [...articles];
		if (articleSorter === "oldest-to-newest") {
			sorted.reverse();
		}
		setSortedArticles(sorted);
	}, [articleSorter, articles]);

	const filteredArticles = sortedArticles.filter((article) =>
		article.fields.title.toLowerCase().includes(articleFilter.toLowerCase())
	);

	const indexOfLastArticle = currentPage * pageSize;
	const indexOfFirstArticle = indexOfLastArticle - pageSize;
	const currentArticles = filteredArticles.slice(
		indexOfFirstArticle,
		indexOfLastArticle
	);

	const articleList = currentArticles.map((article) => {
		return (
			<div className="col-lg-4 col-md-6 col-12" key={article.sys.id}>
				<ArticleCard article={article} />
			</div>
		);
	});

	const pageNumbers = [];
	for (let i = 1; i <= Math.ceil(filteredArticles.length / pageSize); i++) {
		pageNumbers.push(i);
	}

	const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
		setArticleFilter(event.target.value);
	};

	return (
		<section className="flex-grow-1 bg-blue">
			<div className="container py-5">
				<div className="d-flex flex-wrap justify-content-between align-items-center">
					<div className="mb-3 mb-md-0">
						<Search handleSearch={handleSearch} />
					</div>
					<div>
						<Sorter
							defaultSort={articleSorter}
							setSorter={setArticleSorter}
							sortPropsVariant="article"
						/>
					</div>
				</div>

				{filteredArticles.length > 0 ? (
					<div className="row mt-4 gy-3 gx-3">{articleList}</div>
				) : (
					<h3 className="search-no-result">
						Sorry, there are no results. Try a different search term.
					</h3>
				)}

				<nav>
					<ul className="pagination">
						{pageNumbers.map((number) => (
							<li key={number}>
								<button
									className={`page-button ${
										currentPage === number ? "active" : ""
									}`}
									onClick={() => setCurrentPage(number)}
								>
									{number}
								</button>
							</li>
						))}
					</ul>
				</nav>
			</div>
		</section>
	);
};

export default ArticlesList;
